import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  mediaTypes: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_MEDIA_TYPES_BUSY: (state, payload) => {
    state.mediaTypes.isBusy = payload;
  },
  LOAD_MEDIA_TYPES_SUCCESS: (state, payload) => {
    state.mediaTypes.data = payload.data;
    state.mediaTypes.error = null;
  },
  LOAD_MEDIA_TYPES_FAIL: (state, payload) => {
    state.mediaTypes.data = null;
    state.mediaTypes.error = payload;
  }
};

const actions = {
  getMediaTypes: ({ commit, rootState }, { projectId, pagination }) => {
    commit('LOAD_MEDIA_TYPES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/media_types${query}`, config)
      .then(response => {
        commit('LOAD_MEDIA_TYPES_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_MEDIA_TYPES_FAIL', error)
      })
      .finally(() => commit('LOAD_MEDIA_TYPES_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};